import ReactMounter from 'lib/ReactMounter';
import SalesMarketingStrategiesPage from 'pages/SalesMarketingStrategiesPage/SalesMarketingStrategiesPage';

ReactMounter.registerComponentToMountOnLoad('SalesMarketingStrategiesPage', SalesMarketingStrategiesPage);
